import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-create-doc-version-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './create-doc-version-dialog.component.html',
  styleUrl: './create-doc-version-dialog.component.scss'
})
export class CreateDocVersionDialogComponent {
  @Input() canDuplicate: boolean = false;
  @Output() confirmed = new EventEmitter<'scratch' | 'duplicate'>();
  @Output() cancelled = new EventEmitter<void>();

  choiceType: 'scratch' | 'duplicate' = 'scratch';

  onConfirm() {
    this.confirmed.emit(this.choiceType);
  }

  onCancel() {
    this.cancelled.emit();
  }
}
